// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--uKGcW";
export var content = "Layout-module--content--DgRZy";
export var emph = "Layout-module--emph--FRlJd";
export var footerImage = "Layout-module--footer-image--vNFl5";
export var hoverColor = "Layout-module--hover-color--ukSZM";
export var hoverShadow = "Layout-module--hover-shadow--JxbI2";